import { cn } from '@/libs/shadcn';
import { Spinner } from '../../spinner/spinner';

interface SuspenseFallbackProps {
  containerClassName?: string;
  spinnerClassName?: string;
}
export default function SuspenseFallback({
  containerClassName,
  spinnerClassName,
}: SuspenseFallbackProps) {
  return (
    <div
      className={cn(
        'flex justify-center items-center flex-1 h-screen',
        containerClassName
      )}
    >
      <Spinner className={cn('size-12', spinnerClassName)} />
    </div>
  );
}
